// import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({ parentcompany, fullcompanylist, accounts, formData, onInputChange }) => {
    // const accountOptions = [
    //     { name: 'Test Account 1' },
    //     { name: 'Test Account 2' },
    //     { name: 'Test Account 3' },
    // ];
    // console.log(fullcompanylist, "fullcompanylist");

    return (
        <>
            <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
                <div className="col-12">
                    <p className="boxLabel m-0">Details</p>
                </div>
                {/* check box */}


                
                {/* <div style={{ marginBottom: '12px', display: 'flex', gap: '150px', padding: '0 12px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: '400px', marginBottom: '18px' }}>
                        <input
                            type="checkbox"
                            checked={formData.isGroupWarehouse || false}
                            onChange={(e) => {
                                onInputChange('isGroupWarehouse', e.target.checked);
                            }}
                            className="form-check-input me-2"
                            style={{
                                width: '15px', height: '15px',
                                backgroundColor: formData.isGroupWarehouse ? '#270B79' : 'white',

                                borderColor: "#270B79"
                            }}
                        />
                        Is Group Warehouse
                    </label>
                </div> */}



                {/* check box */}

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Warehouse Name"
                                label="Warehouse Name"
                                style={{ height: "30px" }}
                                value={formData.warehouseName}
                                onChange={(e) => onInputChange('warehouseName', e.target.value)}
                            />
                        </div>
                    </div>

                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={fullcompanylist || []}
                                label="Company"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.company}
                                onChange={(value) => onInputChange('company', value)}
                                placeholder=""
                            />
                        </div>
                    </div>
                    {/* <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={parentcompany || []}
                                label="Parent Warehouse"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.parentWarehouse}
                                onChange={(value) => onInputChange('parentWarehouse', value)}
                                placeholder=""

                            />
                        </div>
                    </div> */}
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={accounts || []}
                                label="Account"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.account}
                                onChange={(value) => onInputChange('account', value)}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Abbr"
                                label="Abbr"
                                style={{ height: "30px" }}
                                value={formData.abbr}
                                onChange={(e) => onInputChange('abbr', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
                <div className="col-12">
                    <p className="boxLabel m-0">Warehouse Contact Info</p>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Phone No."
                                label="Phone No."
                                style={{ height: "30px" }}
                                value={formData.phoneNo}
                                onChange={(e) => onInputChange('phoneNo', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Mobile No."
                                label="Mobile No."
                                style={{ height: "30px" }}
                                value={formData.mobileNo}
                                onChange={(e) => onInputChange('mobileNo', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Address Line 1"
                                label="Address Line 1"
                                style={{ height: "30px" }}
                                value={formData.addressLine1}
                                onChange={(e) => onInputChange('addressLine1', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Address Line 2"
                                label="Address Line 2"
                                style={{ height: "30px" }}
                                value={formData.addressLine2}
                                onChange={(e) => onInputChange('addressLine2', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="County"
                                label="County"
                                style={{ height: "30px" }}
                                value={formData.county}
                                onChange={(e) => onInputChange('county', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="State/Province"
                                label="State/Province"
                                style={{ height: "30px" }}
                                value={formData.stateProvince}
                                onChange={(e) => onInputChange('stateProvince', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="City/Town"
                                label="City/Town"
                                style={{ height: "30px" }}
                                value={formData.cityTown}
                                onChange={(e) => onInputChange('cityTown', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Postal Code"
                                label="Postal Code"
                                style={{ height: "30px" }}
                                value={formData.postalCode}
                                onChange={(e) => onInputChange('postalCode', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Tab1;